export default "__VITE_ASSET__CWwtsJdr__"